import React from 'react'
import Layout from 'components/PrivateRoutes/Layout'

const Messages = (props) => {
  return (
    <Layout {...props} title="Meldinger">
    </Layout>
  )
}

export default Messages
